// Author yjb
// Date 2022-02-07 14:49:16

class ImfEmSicIesmrReasonIesmrr {
constructor({
        id = null,
        parentId = '',
        name = '',
        seq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.parentId = parentId;
    this.name = name;
    this.seq = seq;
    this.remark = remark;
}
}

function newEntity() {
return new ImfEmSicIesmrReasonIesmrr();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.statusCollection.imfEmSicIesmrReasonIesmrr.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'parentId',
        label: 'label.em.statusCollection.imfEmSicIesmrReasonIesmrr.grid.parentId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'name',
        label: 'label.em.statusCollection.imfEmSicIesmrReasonIesmrr.grid.name',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'level',
        label: 'label.em.statusCollection.imfEmSicIesmrReasonIesmrr.grid.level',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.em.statusCollection.imfEmSicIesmrReasonIesmrr.grid.nodeCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'seq',
        label: 'label.em.statusCollection.imfEmSicIesmrReasonIesmrr.grid.seq',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.imfEmSicIesmrReasonIesmrr.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    parentIdFilter : '',
    nameFilter : '',
    levelFilter : '',
    nodeCodeFilter : '',
    seqFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.statusCollection.imfEmSicIesmrReasonIesmrr.filter.name',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'levelFilter',
        label: 'label.em.statusCollection.imfEmSicIesmrReasonIesmrr.filter.level',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'nodeCodeFilter',
        label: 'label.em.statusCollection.imfEmSicIesmrReasonIesmrr.filter.nodeCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'parentId',
        label: 'label.em.statusCollection.imfEmSicIesmrReasonIesmrr.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'imfEmSicIesmrReasonIesmrr'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'name',
        label: 'label.em.statusCollection.imfEmSicIesmrReasonIesmrr.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'seq',
        label: 'label.em.statusCollection.imfEmSicIesmrReasonIesmrr.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.imfEmSicIesmrReasonIesmrr.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {ImfEmSicIesmrReasonIesmrr, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
